export default __webpack_public_path__ + "static/media/snow.85a3efda.png";